import bind from './index'
// import {util} from '@utils'

export default [{
    path: '/bindMobile',
    name: 'bindMobile',
    component: bind,
}]